import ko from 'vuetify/es5/locale/ko'

export default {
    ...ko,

    tvsm: {
        loginfailcode: {
            1: '등록되지 않은 사용자입니다.',
            2: '사용자 인증에 실패했습니다.'
        },
        next: '다음',
        language: '한국어',
        gendershort: { 1: 'M', 2: 'F' },
        gender: { 1: 'Male', 2: 'Female' },
        usertype: {1:'관리자', 2:'의사', 3:'스태프'},
        pattype: {1:'신생아', 2:'소아', 3:'성년'},

        menu: {
            tvsmList: 'TVSM 리스트',

            history: '이력',
            videoCallHistory: '화상이력',
            videoCallReservationHistory: '화상예약이력',

            management: '관리',
            group: '그룹관리',
            user: '사용자관리',
            patient: '환자관리',
            device: '장치관리'
        },
        header: {
            seq: '순번',
            status: '상태',
            group: '그룹',
            deviceName: '장치명',
            patientNameAndId: '환자ID/이름',
            patientStatus: '환자상태',
            birthday: '생년월일',
            ageSexBloodType: '나이/성별/혈액형',
            heightWeight: '키/몸무게',
            detail: '상세',

            userName: '의사명',
            patientName: '환자명',
            startTime: '시작시간',
            endTime: '종료시간',
            duration: '상담시간',

            requestTime: '요청시간',
            requestType: '요청유형',
            reserveTime: '예상시작시간',
            videocall: '영상통화'
        },
        alert: {
            noConnection: '존재하지 않는 연결입니다.'
        }
    },

    common: {
        search: '검색',
        login: '로그인',
        logout: '로그아웃',
        cancel: '취소',
        submit: '확인',
        updated: '수정되었습니다',
        created: '생성되었습니다',
        deleted: '삭제되었습니다',
        start: '시작',
        addGroup: '그룹 생성',
        noMemo: '메모없음',
        update: '수정',
        delete: '삭제',
        memo: '메모',
        groupName: '그룹명',
        confirmDelete: '"{0}"를 삭제하시겠습니까?',
        editDelete: '수정/삭제',
        addPatient: '환자 생성',
        ID: '아이디',
        name: '이름',
        type: '유형',
        age: '나이',
        sex: '성별',
        bloodType: '혈액형',
        height: '키',
        weight: '몸무게',
        addUser: '사용자 생성',
        pacemaker: '페이스메이커',
        phone: '전화번호',
        email: '이메일',
        remoteControl: '장비제어',
        modelName: '모델명',
        lastUpdated: '마지막 업데이트 시간',
        requestType: {
            1: '일반',
            2: '긴급'
        },

        menu: {
            account: '내 계정'
        }
    }

}